import { jsxs, jsx } from "react/jsx-runtime";
import { sectionFadeInStyle } from "./utils.js";
import { ProductHighlightCard } from "../ProductHighlightCard.js";
function DataProductHighlightPart({
  part
}) {
  const data = part.data;
  if (!data || !data.stacklineSku) return null;
  return /* @__PURE__ */ jsxs("div", { style: { animation: "concierge-fade-in 0.35s ease-out both" }, children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
    /* @__PURE__ */ jsx(
      ProductHighlightCard,
      {
        stacklineSku: data.stacklineSku,
        reason: data.reason
      }
    )
  ] });
}
export {
  DataProductHighlightPart
};
//# sourceMappingURL=DataProductHighlightPart.js.map
